import React from "react";
import Headline from "~/assets/js/components/Typography/Headline";
import i18n from "~/assets/js/Helpers/i18n";

const DeliveryAreas = () => {
    const stores = reactConfig.footerLocationMenu;
    return (
        <div className="footer_areas">
            <Headline size={6} resizable>
                {i18n.t("newFooter.deliveryAreasTitle")}
            </Headline>
            <div className="footer_areas_list">
                {stores.map((store) => {
                    return (
                        <a
                            key={store.content}
                            href={store.href}
                            className="footer_areas_list_link"
                        >
                            {store.content}
                        </a>
                    );
                })}
            </div>
        </div>
    );
};

export default DeliveryAreas;
